if (!window.kleoneAncientCtaReady) {
  window.kleoneAncientCtaReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-kan-cta]');
    if (!link) return;
    if (link.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const label = link.querySelector('[data-kan-cta-label]');
    link.dataset.originalLabel = label.textContent;
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('aria-busy', 'true');
    link.setAttribute('tabindex', '-1');
    label.textContent = link.dataset.loadingLabel || 'Checking stock...';
  }, true);

  // Restore a usable CTA when returning to a page from the browser's cache.
  window.addEventListener('pageshow', () => {
    for (const link of document.querySelectorAll('a[data-kan-cta][aria-disabled="true"]')) {
      link.querySelector('[data-kan-cta-label]').textContent = link.dataset.originalLabel;
      link.removeAttribute('aria-disabled');
      link.removeAttribute('aria-busy');
      link.removeAttribute('tabindex');
    }
  });
}
